<template>
<div>
  <div v-if="!isShowComment && isEditableComment"
    class="expert-comment">
    <Button type="success"
      icon="ios-add-circle-outline"
      @click="showComment">コメントを追加する</Button>
  </div>
  <div v-else
    class="expert-comment">
    <Input type="textarea"
      :autosize="{minRows: 2,maxRows: 5}"
      v-model="item.data.expertComment"
      v-if="isEditableComment" />
    <div v-else-if="this.item.data.expertComment"
      class="expert-comment">
      <div class="expert-comment-text">
        先生のコメント：{{ item.data.expertComment }}
      </div>
    </div>
    <!--
    <Icon type="ios-arrow-dropleft"
      @click="closeComment" />
    -->
  </div>
</div>
</template>
<script>
export default {
  data() {
    return {
      isShowComment: false
    }
  },
  props: ['item', 'groupIndex', 'itemIndex', 'isEditableComment'],
  computed: {},
  mounted: function () {
    if (this.item && this.item.data.expertComment) {
      this.isShowComment = true
    }
  },
  methods: {
    showComment: function () {
      if (this.item.data.expertComment === undefined) {
        this.addComment()
      }
      this.isShowComment = true
    },
    addComment: function () {
      this.$eventHub.$emit(
        'addComment',
        this.groupIndex,
        this.itemIndex,
        'expertComment'
      )
    }

  }
}
</script>
